import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import { NewMenuItem } from '../../data/MenuItem';
import addUrlHostName from '../../utils/addUrlHostname';
import IconComponent from '../Icon';
import MegaMenu from './MegaMenu';

type FlyoutType = {
  menuItems: NewMenuItem[];
  hasLeftText?: boolean;
};

function Flyout({ menuItems, hasLeftText = false }: FlyoutType) {
  return (
    <ul className={twMerge('z-40 flex h-full items-center space-x-2')}>
      {menuItems.map((item) => (
        <li
          key={item.id}
          className={twMerge(
            'group static',
            'hover:text-site-primary-600 text-site-neutrals-800 flex h-full',
            'py-4 text-base font-bold',
            'border-t-site-neutrals-0 lgS:px-4 border-t-4',
            hasLeftText ? 'px-2' : 'px-4',
            'hover:border-b-site-primary-200 hover:border-b-[6px]',
          )}
        >
          <a
            href={addUrlHostName(item.url || '')}
            className={twMerge(
              'flex h-10 items-center justify-center text-nowrap focus:outline-none [&_svg]:ml-2',
              item.url ? '' : 'pointer-events-none',
            )}
          >
            {item.title}
            {item.sections.length > 0 && (
              <IconComponent
                iconName="ExpandMore"
                size="IconM"
                className="bg-site-neutrals-800 group-hover:bg-site-primary-600 ml-1 transition duration-200 group-hover:rotate-180"
              />
            )}
          </a>
          {item.sections.length > 0 && (
            <>
              <div className="bg-site-neutrals-900/40 pointer-events-none invisible absolute inset-0 top-20 z-20 h-[100vh] w-full backdrop-blur-[1px] group-hover:visible" />
              <MegaMenu subMenuItem={item} />
            </>
          )}
        </li>
      ))}
    </ul>
  );
}

export { type FlyoutType };

export default Flyout;
